<template>
  <div class="survey-shortcode-entry">
    <div v-if="showTurnstile" class="turnstile-container">
      <div class="validation-text">Validando navegador...</div>
      <CloudflareTurnstileWidget theme="auto" @success="onTurnstileSuccess" @expired="onTurnstileError" />
    </div>

    <pre-survey-form v-else :is-submitting-form="isSubmittingForm" :survey-id="surveyId" using-shortcode @automatic-submit="onSubmit" @submit="onSubmit" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import surveyEntryMixin from '@/modules/survey/mixins/survey-entry-mixin'
import CloudflareTurnstileWidget from '@/modules/survey/views/components/CloudflareTurnstileWidget.vue'
import PreSurveyForm from '@/modules/survey/views/components/PreSurveyForm.vue'

export default {
  name: 'SurveyShortcodeEntry',
  components: {
    CloudflareTurnstileWidget,
    PreSurveyForm
  },
  mixins: [surveyEntryMixin],
  data: () => ({
    showTurnstile: true,
    surveyId: null,
    isSubmittingForm: false
  }),
  computed: {
    shortCode() {
      return this.$route.params.shortCode
    }
  },
  methods: {
    ...mapActions('survey', ['authenticateUserFromShortCode']),

    onTurnstileError(message) {
      console.error('Turnstile error, verifique se o domínio está autorizado no Turnstile.', message)
      this.$snackbar({
        message: 'Não foi possível carregar a verificação. Tente abrir o link em uma nova aba.',
        snackbarColor: 'error'
      })
    },

    async onTurnstileSuccess(token) {
      try {
        this.isSubmittingForm = true
        this.surveyId = await this.authenticateUserFromShortCode({
          shortCode: this.shortCode,
          turnstileCode: token
        })
        this.showTurnstile = false
      } catch (error) {
        this.redirectToError(error)
      } finally {
        this.isSubmittingForm = false
      }
    },

    onSubmit() {
      this.$router.push({ name: 'survey-form', params: { surveyId: this.surveyId } })
    }
  }
}
</script>

<style scoped>
.survey-shortcode-entry {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  width: 100%;
}

.turnstile-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.validation-text {
  font-size: 2rem;
  font-weight: 500;
}
</style>
